import { render, staticRenderFns } from "./CatalogExhibitorListButton.vue?vue&type=template&id=8413bd8e"
import script from "./CatalogExhibitorListButton.vue?vue&type=script&lang=ts"
export * from "./CatalogExhibitorListButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports